import { render, staticRenderFns } from "./MultiTable.vue?vue&type=template&id=38f1ecf4"
import script from "./MultiTable.vue?vue&type=script&lang=js"
export * from "./MultiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports